// extracted by mini-css-extract-plugin
module.exports = {"container":"MidBanner_container__z7IDY","link":"MidBanner_link__wIm4x"};